import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { Message } from '@/modules/messenger/_modules/message/models/Message';
import { User } from '@/modules/user/models/User';
import { ModelType } from '@/modules/core/app/constants/ModelType';

export class MessageMention extends BaseEntityModel {
  id?: number;

  modelType?: ModelType.USER;

  modelId?: number;

  messageId?: number;

  /**
   * @relationship
   */
  message?: Message;

  /**
   * @relationship
   */
  user?: User;

  constructor(model: Partial<MessageMention> = {}) {
    super(model);

    this.id = model.id;
    this.modelType = model.modelType;
    this.modelId = model.modelId;
    this.messageId = model.messageId;

    // @ts-ignore
    this.message = Message.mapModelOrNull(model.message);
    // @ts-ignore
    this.user = User.mapModelOrNull(model.user);
  }

  getModelName(): ModelType {
    return ModelType.MESSAGE_MENTION;
  }
}
